import { ROLES } from 'constants/roles';

export const isUnregisteredRole = (roles: string[]) => roles.includes(ROLES.UNREGISTERED);
